var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeSecureEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.64913,
    y: 1.64913,
    width: 184.702,
    height: 184.702,
    rx: 54.4212,
    fill: "#E7FFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.64913,
    y: 1.64913,
    width: 184.702,
    height: 184.702,
    rx: 54.4212,
    stroke: "#45E5E7",
    strokeWidth: 3.29826
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.503 62.9172H52.7549C51.6352 62.9172 50.5614 63.3595 49.7697 64.1467C48.978 64.934 48.5332 66.0017 48.5332 67.115V124.142H52.7549V67.115H115.764V65.3939C115.766 64.5149 116.022 63.6551 116.503 62.9172Z",
    fill: "#1D53E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.199 84.3037H133.977V124.162H138.199V84.3037Z",
    fill: "#1D53E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.937 115.998H60.8596V75.9508H115.763V72.8025H57.6934V119.146H129.103V84.3044H125.937V115.998Z",
    fill: "#1D53E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.228 135.978C41.228 137.092 41.6728 138.159 42.4645 138.947C43.2563 139.734 44.3301 140.176 45.4497 140.176H141.367C142.486 140.176 143.56 139.734 144.352 138.947C145.144 138.159 145.589 137.092 145.589 135.978V127.583H41.228V135.978ZM45.4497 131.781H141.346V135.978H45.4497V131.781Z",
    fill: "#1D53E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.465 107.834L93.3886 111.801L100.333 107.834C102.024 106.851 103.424 105.444 104.395 103.753C105.366 102.062 105.872 100.147 105.864 98.1999V87.3066L93.3886 80.1494L80.9134 87.3066V98.1999C80.9048 100.149 81.4136 102.067 82.3883 103.758C83.363 105.45 84.7692 106.855 86.465 107.834ZM83.0243 88.524L93.3886 82.5631V95.9751H103.753V98.1999C103.756 99.7649 103.344 101.303 102.558 102.659C101.772 104.015 100.641 105.141 99.2778 105.924L93.3886 109.303V95.9751H83.0243V88.524Z",
    fill: "#1D53E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.26 62.8108H142.149V56.2203C142.149 54.0189 141.28 51.9054 139.728 50.3351C138.177 48.7647 136.067 47.8632 133.853 47.8247H130.877C128.656 47.8523 126.535 48.749 124.975 50.3205C123.414 51.892 122.539 54.0117 122.539 56.2203V62.8108H120.428C120.269 62.8235 120.113 62.8589 119.964 62.9158C119.375 63.0148 118.84 63.3176 118.454 63.7708C118.067 64.224 117.855 64.7984 117.853 65.3925V67.0926V72.8015V75.9499V79.623C117.853 80.3076 118.127 80.9643 118.613 81.4484C119.1 81.9326 119.761 82.2046 120.449 82.2046H144.26C144.934 82.1828 145.573 81.9012 146.041 81.4194C146.51 80.9376 146.772 80.2933 146.772 79.623V65.3925C146.772 64.7221 146.51 64.0778 146.041 63.596C145.573 63.1142 144.934 62.8326 144.26 62.8108ZM137.927 62.8108H126.74V56.2203C126.739 55.1214 127.173 54.0662 127.946 53.2813C128.72 52.4964 129.772 52.0445 130.877 52.0225H133.853C134.402 52.0222 134.945 52.1316 135.45 52.344C135.955 52.5565 136.413 52.8677 136.795 53.2593C137.177 53.6508 137.476 54.1147 137.674 54.6234C137.872 55.132 137.965 55.6751 137.948 56.2203L137.927 62.8108Z",
    fill: "#1D53E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeSecureEnvironment);
export default __webpack_public_path__ + "static/media/SafeSecureEnvironment.ec180ee75b92e593128208d474589748.svg";
export { ForwardRef as ReactComponent };